import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Search, Store, Package, ShoppingCart } from 'lucide-react';
import { useT } from '../i18n/I18nContext';
import { useAuth } from '../contexts/AuthContext';
import useShopTools from '../hooks/useShopTools';

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useT();
  const { user } = useAuth();
  const { isEnabled } = useShopTools();

  const NAV_ITEMS = [
    { path: '/home', icon: Home, label: t('nav.home') },
    { path: '/search', icon: Search, label: t('nav.search') },
    { path: '/scopri', icon: Store, label: t('nav.discover') },
  ];

  // v1.8.2 — shop-owner shortcuts appear ONLY when the corresponding
  // tool is enabled AND the user actually owns a shop. Non-owner
  // customers never see these entries.
  if (user?.has_shop) {
    if (isEnabled('inventario')) {
      NAV_ITEMS.push({ path: '/inventario', icon: Package, label: 'Magazzino' });
    }
    if (isEnabled('cassa')) {
      NAV_ITEMS.push({ path: '/cassa', icon: ShoppingCart, label: 'Cassa' });
    }
  }

  const isActive = (path) => {
    if (path === '/home') return location.pathname === '/home';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-100 bottom-nav z-40 safe-area-pb" data-testid="bottom-nav">
      <div className="max-w-lg mx-auto flex justify-around items-center h-16">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center flex-1 h-full bottom-nav-item ${active ? 'active' : ''}`}
              data-testid={`nav-${item.path.replace('/', '')}`}
            >
              <Icon className={`w-5 h-5 mb-1 ${active ? 'text-blue-600' : 'text-slate-400'}`} />
              <span className={`text-xs font-medium ${active ? 'text-blue-600' : 'text-slate-400'}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
